<app-print-layout (cancelar)="cancelar()">
  <div class="p-4 content page-break" *ngFor="let osa of model">
    <div class="card card-outline">
      <div class="card-body p-2">

        <div
          [class.minuta]="
            osa?.status?.nome !== 'Aprovado' && osa?.status?.nome !== 'Homologado'
          "
        ></div>

        <div>
          <div
            class="row border border-dark d-flex justify-content-center align-items-center"
            style="height: 70px;"
          >
            <div class="col-12 text-center">
              <p class="h5 font-weight-bold text-center">
                Ordem de Serviço de Auditoria nº {{ osa?.numero }}
              </p>
            </div>
          </div>
          <div class="row border border-top-0 border-dark">
            <div class="col-6 border-right border-dark">
              <strong>Origem:</strong>
              <p>{{ osa?.origem?.nome }}</p>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <strong>Tipo:</strong>
                <p>{{ osa?.tiposAuditorias?.nome }}</p>
              </div>

              <div>
                <strong>Subtipo:</strong>
                <p *ngFor="let item of osa?.subTiposAuditorias">
                  <strong>Nome: </strong>{{ item?.nome }}
                </p>
              </div>
            </div>
          </div>
          <div class="row border border-top-0 border-dark">
            <div class="col-12">
              <strong>Ôrgão a ser Auditado:</strong>
              <p>{{ osa?.unidadeGestora?.nome }}</p>
            </div>
          </div>

          <div class="row border border-top-0 border-dark">
            <div class="col-12">
              <strong>Objeto:</strong>
              <p>{{ osa?.objeto }}</p>
            </div>
          </div>

          <div class="row border border-top-0 border-dark">
            <div class="col-12">
              <strong>Responsável da UG:</strong>
              <p>{{ osa?.unidadeGestora?.responsavel }}</p>
            </div>
          </div>

          <div class="row border border-top-0 border-dark">
            <div class="col-4 border border-top-0 border-left-0 border-bottom-0 border-dark">
              <strong>Periodo a ser Auditavel</strong>
            </div>
            <div class="col-8">
              <p>{{ osa?.periodoAuditado }}</p>
            </div>
          </div>

          <div class="row border border-top-0 border-dark">
            <div class="px-0 col-3 border border-top-0 border-left-0 border-bottom-0 border-dark">
              <div class="border-bottom border-dark w-100 col-sm-12">
                <strong>Prazo de Execução</strong>
              </div>

              <div class="row">
                <div class="col-sm-6 p-2 border border-top-0 border-left-0 border-bottom-0 border-dark">
                  <strong>Inicio:</strong>
                  <p>{{ osa?.dataInicioRealizacao | date: "dd/MM/yyyy" }}</p>
                </div>
                <div class="col-sm-6 p-2">
                  <strong>Fim:</strong>
                  <p>{{ osa?.dataFimRealizacao | date: "dd/MM/yyyy" }}</p>
                </div>
              </div>
            </div>

            <!-- Prazo execução -->
            <div class="px-0 col-3 border border-top-0 border-left-0 border-bottom-0 border-dark">
              <div class="border-bottom border-dark w-100 col-sm-12">
                <strong>Prazo para apresentação das <br>constatações preliminares:</strong>
              </div>
              <p class="p-2">{{ osa?.dataConstatacoesPreliminares | date: "dd/MM/yyyy" }}</p>
            </div>

            <div class="px-0 col-3 border border-top-0 border-left-0 border-bottom-0 border-dark text-center">
              <div class="border-bottom border-dark w-100 col-sm-12">
                <strong>Data para apresentação do Relatório</strong>
              </div>
              <p class="p-2">{{ osa?.dataApresentacaoRelatorio | date: "dd/MM/yyyy" }}</p>
            </div>

            <div class="px-0 col-3 text-center">
              <div class="border-bottom border-dark w-100 col-sm-12">
                <strong>Total de Dias Úteis para execução</strong>
              </div>
              <p class="p-2">{{ osa?.qtdeDiasUteisExecucao }}</p>
            </div>
          </div>

          <!-- Equipe -->

          <div class="row border border-top-0 border-dark">
            <div class="col-12 border border-top-0 border-left-0 border-bottom-0 border-dark">
              <strong>Componente da Equipe Tácnica</strong>
            </div>

          </div>

          <div class="row border border-top-0 border-dark" *ngIf="osa?.osaEquipe?.length <= 0; else auditor">
            <div class="col-12">
              <p class="text-center"><strong>Nenhum Auditor Encontrado</strong></p>
            </div>
          </div>
          <ng-template #auditor>
            <div class="row border border-top-0 border-dark" *ngFor="let item of osa?.osaEquipe">
              <div class="col-4">
                <p><strong>Nome: </strong>{{ item?.nomeAuditor }}</p>
              </div>
              <div class="col-4">
                <p><strong>Cargo:</strong> {{ item?.cargo }}</p>
              </div>
              <div class="col-4">
                <p><strong>Matricula:</strong> {{ item?.matricula }}</p>
              </div>
            </div>
          </ng-template>

          <div class="row border border-top-0 border-dark">
            <div class="col-12 border border-top-0 border-left-0 border-bottom-0 border-dark">
              <strong>Aprovações</strong>
            </div>

          </div>
          <!-- Elaboração e aprovações -->
          <div class="row border border-top-0 border-dark">
            <div class="col-12" *ngIf="osa?.assinaturas?.length <= 0">
              <p class="text-center"><strong>Nenhuma aprovação</strong></p>
            </div>

            <div class="col-12" *ngIf="osa?.assinaturas?.length > 0">
              <div class="row">
                <!-- Coluna da esquerda - SubSecretarios -->
                <div class="col-md-6">
                  <ng-container *ngIf="getAssinaturasPorPapel('SubSecretario', osa).length > 0">
                    <h6>SubSecretários ({{ getAssinaturasPorPapel('SubSecretario', osa).length }})</h6>
                    <ol>
                      <li *ngFor="let item of getAssinaturasPorPapel('SubSecretario', osa)">
                        <div>
                          <p class="mb-1" *ngIf="item?.situacao === 1">{{ item?.nome }} aprovou.</p>
                          <p class="mb-1" *ngIf="item?.situacao === 2">{{ item?.nome }} reprovou.</p>
                          <p class="mb-1" *ngIf="item?.situacao === 3">{{ item?.nome }} enviou para aprovação.</p>
                          <p class="mb-1" *ngIf="item?.situacao === 4">{{ item?.nome }} homologou.</p>
                          <p class="mb-0"><em>SubSecretário de Estado e Controle</em></p>
                        </div>
                      </li>
                    </ol>
                  </ng-container>
                </div>

                <!-- Coluna da direita - Secretarios -->
                <div class="col-md-6">
                  <ng-container *ngIf="getAssinaturasPorPapel('Secretario', osa).length > 0">
                    <h6>Secretários ({{ getAssinaturasPorPapel('Secretario', osa).length }})</h6>
                    <ol>
                      <li *ngFor="let item of getAssinaturasPorPapel('Secretario', osa)">
                        <div>
                          <p class="mb-1" *ngIf="item?.situacao === 1">{{ item?.nome }} aprovou.</p>
                          <p class="mb-1" *ngIf="item?.situacao === 2">{{ item?.nome }} reprovou.</p>
                          <p class="mb-1" *ngIf="item?.situacao === 3">{{ item?.nome }} enviou para aprovação.</p>
                          <p class="mb-1" *ngIf="item?.situacao === 4">{{ item?.nome }} homologou.</p>
                          <p class="mb-0"><em>Secretário de Estado e Controle</em></p>
                        </div>
                      </li>
                    </ol>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</app-print-layout>
